module.exports = {
	"config": {
		"siteTitle": "This and that",
		"siteDescr": "A small (experimental) blog about all kinds of things. The kind of things that I will usually write about are Open Science and Cognitive Science, but also this, that and the other.",
		"siteAuthor": "Asura Enkhbayar",
		"siteTwitterUrl": "https://twitter.com/AsuraEnkhbayar",
		"siteGithubUrl": "https://github.com/Bubblbu",
		"siteEmailUrl": "mailto:asura.enkhbayar@gmail.com",
		"googleAnalyticsId": "UA-102930266-1",
		"linkPrefix": "/this-and-that",
		"GitHubRepository": "this-and-that",
		"GitHubUserName": "Bubblbu",
		"GitHubBaseURL": "https://bubblbu.github.io",
		"disqusShortname": "this-and-that"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-23-hello-world",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-23-hello-world",
				"stem": "index",
				"path": "articles/2017-01-23-hello-world/index.md"
			},
			"requirePath": "articles/2017-01-23-hello-world/index.md",
			"path": "/hello-world/",
			"data": {
				"title": "The idea of an open blog",
				"date": "2017-01-23",
				"layout": "post",
				"path": "/hello-world/",
				"category": "general",
				"description": "Hello World! A short blog post about why I created this webpage and how I want to implement an open & collaborative blog."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-01-27-wittgenstein-draft",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-01-27-wittgenstein-draft",
				"stem": "index",
				"path": "articles/2017-01-27-wittgenstein-draft/index.md"
			},
			"requirePath": "articles/2017-01-27-wittgenstein-draft/index.md",
			"path": "/wittgenstein-draft/",
			"data": {
				"title": "Applying Wittgenstein in Knowledge Discovery & Visualization",
				"date": "2017-01-27",
				"layout": "post",
				"path": "/wittgenstein-draft/",
				"category": "Wittgenstein",
				"description": "Is it possible to take the philosophy of Wittgenstein (possibly the greatest philosopher of the 20th century. He's great. It's tremendous) and use his ideas to design and develop software used in everyday life?"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-03-24-osc2017",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-03-24-osc2017",
				"stem": "index",
				"path": "articles/2017-03-24-osc2017/index.md"
			},
			"requirePath": "articles/2017-03-24-osc2017/index.md",
			"path": "/2017-03-24-osc2017/",
			"data": {
				"title": "Open Sciencing in Berlin",
				"date": "2017-03-24",
				"layout": "post",
				"path": "/2017-03-24-osc2017/",
				"category": "Open Science",
				"description": "Cats, dinosaurs, data dispensers and other open sciency things that happened during the spring equinox in Berlin. \"Putting Open Science into practice\" was the theme of this year's Barcamp Open Science at the Wikimedia Germany, which preceded the 4th annual Open Science Conference"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-07-13-opencon-my-application",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-07-13-opencon-my-application",
				"stem": "index",
				"path": "articles/2017-07-13-opencon-my-application/index.md"
			},
			"requirePath": "articles/2017-07-13-opencon-my-application/index.md",
			"path": "/my-opencon-2016-application/",
			"data": {
				"title": "My OpenCon 2016 Application",
				"date": "2017-07-13",
				"layout": "post",
				"path": "/my-opencon-2016-application/",
				"category": "OpenCon",
				"description": "Want to apply for OpenCon 2017 but hate writing applications? Tried googling 'opencon application tutorial in < 10min'? Say no more... Have a look at mine!"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About this, that & me",
				"layout": "page",
				"path": "/about"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0